import moment from 'moment'
import React from 'react'
import { addToCard, translate } from '../../utils/useful'
// import { checkTextTranslation } from '../../utils/useful'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import CustomLoader from '../CustomLoader';
const isEqual = require('lodash.isequal');



class AddToCardButton extends React.Component {
    state = {
        isLoading: false
    }


    componentDidMount() {
        this.checkProductInCart()
    }

    componentDidUpdate(prevProps) {

        if (prevProps.carts != this.props.carts || this.props.product?._id != prevProps.product?._id || this.props.variants != prevProps.variants || this.props.additionals != prevProps.additionals) {
            this.checkProductInCart()
        }
    }



    checkProductInCart() {



        let applet = this.props.applet



        if (this.props.carts?.applets && this.props.carts.applets[applet] && Array.isArray(this.props.carts.applets[applet].items)) {

            let product = this.props.product
            let variants = this.props.variants
            let additionals = this.props.additionals

            let productId = this.props.product?._id
            let currentItemInCart

            let productCount = 0
            let productVariatyCount = 0


            this.props.carts.applets[applet].items.forEach(item => {
                if (item.product?._id == productId) {
                    productCount = productCount + (item.count ?? 0)
                    productVariatyCount++
                    let elementIsEqual = true

                    let dataAdditionals = {}
                    let elementAdditionals = {}

                    if (product.includesVariants && product?.inventory && Array.isArray(product?.inventory.variants)) {

                        if (!(JSON.stringify(item.variants).toLowerCase() == JSON.stringify(variants).toLowerCase())) {
                            elementIsEqual = false
                        }
                    }



                    if (typeof item.additionals == 'object') {

                        for (const [additionalKey, additionalValue] of Object.entries(item.additionals)) {

                            dataAdditionals[additionalKey] = {}

                            if (typeof additionalValue == 'object') {

                                for (const [optionKey, optionValue] of Object.entries(additionalValue)) {

                                    dataAdditionals[additionalKey][optionKey] = { value: optionValue.value }

                                }

                            }
                        }

                    }


                    if (typeof additionals == 'object') {

                        for (const [additionalKey, additionalValue] of Object.entries(additionals)) {

                            elementAdditionals[additionalKey] = {}

                            if (typeof additionalValue == 'object') {

                                for (const [optionKey, optionValue] of Object.entries(additionalValue)) {

                                    elementAdditionals[additionalKey][optionKey] = { value: optionValue.value }

                                }

                            }
                        }

                    }

                    if (elementIsEqual) {

                        // console.log(dataAdditionals)
                        // console.log(elementAdditionals)
                    }

                    if (!isEqual(dataAdditionals, elementAdditionals)) {
                        elementIsEqual = false
                    }


                    if (elementIsEqual) {
                        currentItemInCart = item
                        // console.log("EQUAL",elementAdditionals)

                    }

                }
            });

            // console.log(productCount, productVariatyCount, currentItemInCart)
            this.setState({ productCount, productVariatyCount, currentItemInCart })
        }
    }



    addToCart = (action, count) => {

        if (!this.state.isLoading) {
            let applet = this.props.applet
            console.log('addToCart01', applet)
            let hub = this.props.variables?.targetHub
            console.log('addToCart02', hub)
            let variants = this.props.variants
            console.log('addToCart03', variants)
            let additionals = this.props.additionals
            console.log('addToCart04', additionals)
            let product = this.props.product?._id
            console.log('addToCart05', this.props.product)

            this.setState({ isLoading: true })

            addToCard(applet, hub, product, action, count, variants, additionals, () => {
                this.setState({ isLoading: false })
            })
        }
    }

    proceedToCheckout = () => {

        this.props.changePage('cart')
    }



    render() {

        let colors = this.props.colors
        let background = `linear-gradient(90deg, ${colors?.primaryColor}, ${colors?.secondaryColor})`
        // let productId = this.props.product?._id
        // let applet = this.props.applet
        // let colors = this.props.colors
        // let background = `linear-gradient(90deg, ${colors?.primaryColor}, ${colors?.secondaryColor})`
        // let productIncart
        // let productCount = 0
        
        // if (this.props.cart && this.props.cart[applet] && this.props.cart[applet][productId]) {
            //     productIncart = this.props.cart[applet][productId]
            //     productCount = productIncart.count
            // }
            
            let productCount = this.state.productCount
            let productVariatyCount = this.state.productVariatyCount
            let currentItemInCart = this.state.currentItemInCart
            // console.log('currentItemInCart',currentItemInCart)

        return (
            <div>
                {(!currentItemInCart) ? (
                    <button onClick={() => this.addToCart('add', 1)} className="buy-btn font-size-15 br-6 flexcc" style={{ padding: "10px 0px", background: background ?? '#007aff', width: '200px' }}>
                        {this.state.isLoading ? (
                            <div className='w-100 flexcc' style={{ height: 21.5 }}>
                                <CustomLoader isLoading={true} type={'ThreeDots'} color={'#fff'} height={15} width={50} />
                            </div>
                        ) : (
                            <p className='text-normal text-bold'>{this.props.label ?? translate("Add to cart")}</p>
                        )}
                    </button>
                ) : (
                    <div>

                        <div className=" buy-btn flexcb br-6" style={{ padding: "10px 0px", background: background ?? '#007aff', width: '200px' }}>
                            <button className='flexcc mx-2' onClick={() => this.addToCart('subtract', 1)} style={{ cursor: 'pointer' }}>
                                <img className='invert' src='/assets/icons/minimize.svg' width={20} />
                            </button>
                            {this.state.isLoading ? (
                                <div className='w-100 flexcc' style={{ height: 21.5 }}>
                                    <CustomLoader isLoading={true} type={'ThreeDots'} color={'#fff'} height={15} width={50} />
                                </div>
                            ) : (
                                <span className='text-semibold' style={{ fontSize: 15 }}>{currentItemInCart?.count} {translate("Items")}
                                    {/* <span style={{ color: '#ffffff ', fontSize: 15 }}>{(productCount == 1) ? 'Number' : 'Numbers'}</span> */}
                                </span>
                            )}
                            <button className='flexcc mx-2' onClick={() => this.addToCart('add', 1)} style={{ cursor: 'pointer' }}>
                                <img className='invert' src='/assets/icons/plus.svg' width={20} />
                            </button>
                        </div>



                    </div>
                )}

                {productCount > 0 && (
                    <div className='mt-2'>
                        {productVariatyCount > 1 && (
                            <div>
                                <button className=' text-small'>
                                    <p style={{ color: '#007aff' }}>{productCount} items in {productVariatyCount} varieties</p>
                                </button>
                            </div>
                        )}
                        <div>
                            <button className='mt-1 text-small' onClick={() => this.proceedToCheckout()}>
                                <p style={{ color: '#007aff' }}>{translate("Proceed to check out")}</p>
                            </button>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}



const mapStateToProps = state => ({ carts: state.carts, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddToCardButton);

// export default AddToCardButton;